module.exports = {
  label: {
    headerTitle: 'Company Management',
    uploadLogo: 'Upload Company Logo',
    changeLogo: 'Do you want to change company logo',
    AddheaderTitle: 'Add Company Management',
    EditheaderTitle: 'Edit Company Management',
    companyName: 'Company Name',
    search: 'Search...',
    showPagination: {
      showing: 'Showing',
      to: 'to',
      of: 'of',
      entries: 'entries',
      rowsSelected: 'rows selected'
    },
    tooltips: {
      delete: 'Delete',
      edit: 'Edit'
    },
    buttons: {
      add: 'Add',
      save: 'Save',
      cancel: 'Cancel'
    }
  }
}
